import { render, staticRenderFns } from "./PasswordResult.vue?vue&type=template&id=7f304e6c"
import script from "./PasswordResult.vue?vue&type=script&lang=ts"
export * from "./PasswordResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports